import Form from "react-bootstrap/Form";
import { isValidMedicareNumber } from "../../validation/medicareNumber";
import { isValidVeteranNumber } from "../../validation/veteranNumber";
import { isValidHealthCareCardNumber } from "../../validation/healthCareCardNumber";
import { isValidWebAddress } from "../../validation/webAddress";

const buildShortTextQuestiom = (question) => {
  switch (question.ValidationType) {
    case "Email":
      return (
        <Form.Control
          type="email"
          name={question.Name}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          required={question.IsMandatory}
        ></Form.Control>
      );
    case "General phone number":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          inputMode="numeric"
          pattern="[0-9]{10}"
          minLength={10}
          maxLength={10}
          required={question.IsMandatory}
          onChange={(event) => {
            event.target.value = event.target.value
              .replace(/\D/g, "")
              .slice(0, 10);
          }}
        ></Form.Control>
      );
    case "Mobile number":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          inputMode="numeric"
          pattern="[0-9]{10}"
          minLength={10}
          maxLength={10}
          required={question.IsMandatory}
          onChange={(event) => {
            event.target.value = event.target.value
              .replace(/\D/g, "")
              .slice(0, 10);
          }}
        ></Form.Control>
      );
    case "Medicare number":
    case "Medicare Number":
      return (
        <div className="d-flex gap-2 align-items-start medicare-number-group">
          <div>
            <Form.Label className="mb-1 small invisible">Medicare</Form.Label>
            <Form.Control
              name={question.Name}
              type="text"
              inputMode="numeric"
              placeholder="9999 99999 9"
              className="form-control"
              minLength={question.MinLength}
              maxLength={question.MaxLength}
              required={question.IsMandatory}
              onChange={(event) => {
                const digits = event.target.value
                  .replace(/\D/g, "")
                  .slice(0, 10);
                event.target.value = [
                  digits.slice(0, 4),
                  digits.slice(4, 9),
                  digits.slice(9, 10),
                ]
                  .filter(Boolean)
                  .join(" ");

                let newClass = event.target.className
                  .replace("is-invalid", "")
                  .replace("is-valid", "")
                  .trimEnd();

                if (digits.length === 0) {
                  event.target.setCustomValidity("");
                  event.target.className = newClass;
                } else if (digits.length < 10) {
                  event.target.setCustomValidity(
                    "Medicare number must contain 10 digits.",
                  );
                  event.target.className = newClass;
                } else if (!isValidMedicareNumber(digits)) {
                  event.target.setCustomValidity(
                    "This is not a valid Medicare number. Please check the digits and try again.",
                  );
                  event.target.className = newClass + " is-invalid";
                } else {
                  event.target.setCustomValidity("");
                  event.target.className = newClass + " is-valid";
                }
              }}
            />
          </div>
          <div>
            <Form.Label
              htmlFor={`${question.Name}_irn`}
              className="mb-1 small"
            >
              IRN
            </Form.Label>
            <Form.Control
              id={`${question.Name}_irn`}
              name={`${question.Name}_irn`}
              type="text"
              inputMode="numeric"
              pattern="[1-4]"
              maxLength={1}
              style={{ width: "3.5rem" }}
              required={question.IsMandatory}
              onChange={(event) => {
                event.target.value = event.target.value
                  .replace(/[^1-4]/g, "")
                  .slice(0, 1);
                let newClass = event.target.className
                  .replace("is-invalid", "")
                  .replace("is-valid", "")
                  .trimEnd();
                if (
                  event.target.value &&
                  !/^[1-4]$/.test(event.target.value)
                ) {
                  event.target.className = newClass + " is-invalid";
                } else {
                  event.target.className = newClass;
                }
              }}
            />
          </div>
        </div>
      );
    case "Veteran number":
    case "Veteran Number":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          minLength={question.MinLength}
          maxLength={9}
          required={question.IsMandatory}
          onChange={(event) => {
            const sanitized = event.target.value
              .replace(/[^A-Za-z0-9]/g, "")
              .slice(0, 9);
            event.target.value = sanitized;

            let newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            if (sanitized.length === 0) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (!isValidVeteranNumber(sanitized)) {
              event.target.setCustomValidity(
                "Veteran number must contain letters and numbers only, up to 9 characters.",
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass + " is-valid";
            }
          }}
        ></Form.Control>
      );
    case "Health care number":
    case "Health Care Number":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          inputMode="numeric"
          minLength={16}
          maxLength={16}
          required={question.IsMandatory}
          onChange={(event) => {
            const sanitized = event.target.value
              .replace(/\D/g, "")
              .slice(0, 16);
            event.target.value = sanitized;

            let newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            if (sanitized.length === 0) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (!isValidHealthCareCardNumber(sanitized)) {
              event.target.setCustomValidity(
                "Health Care Card number must be exactly 16 digits.",
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass + " is-valid";
            }
          }}
        ></Form.Control>
      );
    case "Number greater than":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          min={Number(question.ValidationParams[0]) + 1}
          required={question.IsMandatory}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          step="any"
        ></Form.Control>
      );
    case "Number greater than or equal to":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          min={question.ValidationParams[0]}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          required={question.IsMandatory}
          step="any"
        ></Form.Control>
      );
    case "Number less than":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          max={question.ValidationParams[0] - 1}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          required={question.IsMandatory}
          step="any"
        ></Form.Control>
      );
    case "Number less than or equal to":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          max={question.ValidationParams[0]}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          required={question.IsMandatory}
          step="any"
        ></Form.Control>
      );
    case "Number equal to":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          value={question.ValidationParams[0]}
          isreadonly="true"
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          required={question.IsMandatory}
          step="any"
        ></Form.Control>
      );
    case "Number not equal to":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          data-notequalto={question.ValidationParams[0]}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          onChange={(event) => {
            const notEqualTo = event.target.getAttribute("data-notequalto");
            const newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            if (!event.target.value) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (event.target.value === notEqualTo) {
              event.target.setCustomValidity(
                `Value must not equal ${notEqualTo}.`,
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            }
          }}
          required={question.IsMandatory}
        ></Form.Control>
      );
    case "Number between":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          min={question.ValidationParams[0]}
          max={question.ValidationParams[1]}
          required={question.IsMandatory}
          step="any"
        ></Form.Control>
      );
    case "Number not between":
      return (
        <Form.Control
          name={question.Name}
          type="number"
          step="any"
          data-greaterthan={question.ValidationParams[0]}
          data-lessthan={question.ValidationParams[1]}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          onChange={(event) => {
            const greaterThan = Number(
              event.target.getAttribute("data-greaterthan"),
            );
            const lessThan = Number(
              event.target.getAttribute("data-lessthan"),
            );
            const newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            if (!event.target.value) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (
              Number(event.target.value) >= greaterThan &&
              Number(event.target.value) <= lessThan
            ) {
              event.target.setCustomValidity(
                `Value must not be between ${greaterThan} and ${lessThan}.`,
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            }
          }}
          required={question.IsMandatory}
        ></Form.Control>
      );
    case "Text contains":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          data-required-words={question.ValidationParams[0]}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          onChange={(event) => {
            const requiredWords = event.target
              .getAttribute("data-required-words")
              ?.split(",")
              .map((s) => s.trim());
            const value = event.target.value.trim().toLowerCase();
            const allRequiredWordsPresent = requiredWords?.every((s) =>
              value.includes(s.toLowerCase()),
            );
            const newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            if (!value) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (!allRequiredWordsPresent) {
              event.target.setCustomValidity(
                `Value must contain all of: ${requiredWords?.join(", ")}.`,
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            }
          }}
          required={question.IsMandatory}
        ></Form.Control>
      );
    case "Text does not contain":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          data-required-words={question.ValidationParams[0]}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          onChange={(event) => {
            const requiredWords = event.target
              .getAttribute("data-required-words")
              ?.split(",")
              .map((s) => s.trim());
            const value = event.target.value.trim().toLowerCase();
            const requiredWordPresent = requiredWords?.some((s) =>
              value.includes(s.toLowerCase()),
            );
            const newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            if (!value) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (requiredWordPresent) {
              event.target.setCustomValidity(
                `Value must not contain: ${requiredWords?.join(", ")}.`,
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            }
          }}
          required={question.IsMandatory}
        ></Form.Control>
      );
    case "Url":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          required={question.IsMandatory}
          onChange={(event) => {
            const newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            const value = event.target.value.trim();

            if (!value) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (!isValidWebAddress(value)) {
              event.target.setCustomValidity(
                "Please enter a valid web address.",
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            }
          }}
        ></Form.Control>
      );
    case "Whole numbers only":
      return (
        <Form.Control
          name={question.Name}
          type="text"
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          onChange={(event) => {
            // Whole numbers, optionally negative (an optional leading "-"
            // followed by one or more digits).
            const numericPattern = /^-?[0-9]+$/;
            const newClass = event.target.className
              .replace("is-invalid", "")
              .replace("is-valid", "")
              .trimEnd();

            if (!event.target.value) {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            } else if (!numericPattern.test(event.target.value)) {
              event.target.setCustomValidity(
                "Value must contain whole numbers only.",
              );
              event.target.className = newClass + " is-invalid";
            } else {
              event.target.setCustomValidity("");
              event.target.className = newClass;
            }
          }}
          required={question.IsMandatory}
        ></Form.Control>
      );
    default:
      return (
        <Form.Control
          name={question.Name}
          minLength={question.MinLength}
          maxLength={question.MaxLength}
          required={question.IsMandatory}
        ></Form.Control>
      );
  }
};

export default buildShortTextQuestiom;
